/** Builds a single emoji from its Unicode code point (ASCII-safe source). */
function icon(codePoint: number): string {
  return String.fromCodePoint(codePoint);
}

/**
 * Share-template icons built at runtime so bundlers / file encoding cannot corrupt them.
 * Code points chosen for broad WhatsApp support (no ZWJ / variation selectors).
 */
export const SHARE_ICONS = {
  wave: icon(0x1f44b),
  id: icon(0x1f194),
  pin: icon(0x1f4cd),
  calendar: icon(0x1f4c5),
  clock: icon(0x23f0),
  money: icon(0x1f4b0),
  point: icon(0x1f449),
  car: icon(0x1f697),
} as const;

/** Joins blocks with a blank line; lines inside each block stay single-spaced. */
export function joinShareBlocks(...blocks: string[][]): string {
  return blocks
    .map((block) => block.filter(Boolean).join("\n"))
    .filter((block) => block.length > 0)
    .join("\n\n");
}
